var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',{attrs:{"items":_vm.languages,"hide-details":"","dense":""},model:{value:(_vm.$root.$i18n.locale),callback:function ($$v) {_vm.$set(_vm.$root.$i18n, "locale", $$v)},expression:"$root.$i18n.locale"}})
}
var staticRenderFns = []

export { render, staticRenderFns }